// extracted by mini-css-extract-plugin
export default {"root":"style_root__DcUeC","scrollPaper":"style_scrollPaper__dGJeS","paperScrollPaper":"style_paperScrollPaper__LgPIw"};